import { writable } from 'svelte/store';
import { apiFetch } from '../lib/api/client.js';
import { setLicense } from './license.js';
import { setActiveUserId } from '../lib/db/indexeddb.js';

const TOKEN_KEY = 'ytcs:token';
const USERS_KEY = 'ytcs:known-users';

export const authState = writable({
  isAuthenticated: false,
  email: null,
  token: null,
  role: 'user',
  userId: null
});

export function initAuth() {
  const token = localStorage.getItem(TOKEN_KEY);
  const email = localStorage.getItem('ytcs:email');
  const role = localStorage.getItem('ytcs:role') || 'user';
  const userId = localStorage.getItem('ytcs:userId');
  if (token && email && userId) {
    setActiveUserId(userId);
    authState.set({ isAuthenticated: true, email, token, role, userId });
  }
}

export async function register(email, password) {
  const { token, user, license } = await apiFetch('/auth/register', {
    method: 'POST',
    body: { email, password }
  });
  storeSession(token, user.email, user.role, user.id);
  setLicense(license);
  return { user, license };
}

export async function login(email, password) {
  const { token, user, license } = await apiFetch('/auth/login', {
    method: 'POST',
    body: { email, password }
  });
  storeSession(token, user.email, user.role, user.id);
  setLicense(license);
  return { user, license };
}

export async function magicLink(email) {
  const { token, user, license } = await apiFetch('/auth/magic-link', {
    method: 'POST',
    body: { email }
  });
  storeSession(token, user.email, user.role, user.id);
  setLicense(license);
  return { user, license };
}

export async function googleLogin(email) {
  const { token, user, license } = await apiFetch('/auth/google', {
    method: 'POST',
    body: { email }
  });
  storeSession(token, user.email, user.role, user.id);
  setLicense(license);
  return { user, license };
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('ytcs:email');
  localStorage.removeItem('ytcs:role');
  localStorage.removeItem('ytcs:userId');
  setActiveUserId('guest');
  authState.set({ isAuthenticated: false, email: null, token: null, role: 'user', userId: null });
}

export function getKnownUsers() {
  const raw = localStorage.getItem(USERS_KEY);
  return raw ? JSON.parse(raw) : [];
}

function storeSession(token, email, role = 'user', userId = null) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem('ytcs:email', email);
  localStorage.setItem('ytcs:role', role);
  if (userId) localStorage.setItem('ytcs:userId', userId);
  if (userId) setActiveUserId(userId);
  authState.set({ isAuthenticated: true, email, token, role, userId });
  rememberUser({ email, userId, role });
}

function rememberUser(entry) {
  const raw = localStorage.getItem(USERS_KEY);
  const list = raw ? JSON.parse(raw) : [];
  const filtered = list.filter((u) => u.email !== entry.email);
  filtered.unshift(entry);
  localStorage.setItem(USERS_KEY, JSON.stringify(filtered.slice(0, 10)));
}
